/**
 * Exact-decimal conversion at the app's FIXED rates (`constants/exchangeRates`).
 * The amount stays a decimal string end to end; only the rate (a small
 * constant, itself an estimate) is scaled to millionths. Null when either
 * currency is not in the table, so a caller can say "not compared" instead of
 * treating two currencies as 1:1.
 */
import { fixedRatePerUsd } from './currency';
import { fromMicro, toMicro } from './decimal';

const SCALE = BigInt(1000000);
const HALF = BigInt(500000);

export function convertDecimalAtFixedRate(amount: string | null | undefined, from: string, to: string): string | null {
  const micro = toMicro(amount);
  if (micro === null) return null;
  const fromCode = from.trim().toUpperCase();
  const toCode = to.trim().toUpperCase();
  if (fromCode === toCode) return fromMicro(micro);
  const fromRate = fixedRatePerUsd(fromCode);
  const toRate = fixedRatePerUsd(toCode);
  if (!fromRate || !toRate) return null;
  const rate = BigInt(Math.round((toRate / fromRate) * 1000000));
  const scaled = micro * rate;
  const negative = scaled < BigInt(0);
  const abs = negative ? -scaled : scaled;
  const rounded = (abs + HALF) / SCALE;
  return fromMicro(negative ? -rounded : rounded);
}
